import React from "react";

import Icon from "components/Icons/Icon";

import { Button } from "react-bootstrap";

import conxtdOut from "apis/conxtdOut";

const denyWorkOrder = async (site_id, lock_id, username) => {
  try {
    await conxtdOut.post(`/OutLocks/disable/${site_id}`, {
      lock_id,
      username,
    });
  } catch (error) {
    console.log("denyWorkOrderError", error);
  }
};

export default function AllowAccessApiButton({
  site_id,
  lock_id,
  username,
  ...rest
}) {
  return (
    <Button
      size="sm"
      variant="danger"
      onClick={() => denyWorkOrder(site_id, lock_id, username)}
      {...rest}
    >
      <Icon className="fas fa-times mr-2" /> Deny Access
    </Button>
  );
}
